export default "__VITE_ASSET__povvl9nR__"